/**
 * Check if state is loading from a list of isLoading selectors.
 *
 * @param {Array} loadingSelectors
 * @param {Object} state
 *
 * @returns {Bool}
 */
export default (loadingSelectors, state) =>
  loadingSelectors.map(selector => selector(state)).includes(true);



// WEBPACK FOOTER //
// ./src/utilities/isStateLoading.js